module.exports = __webpack_public_path__ + "img/running.d1826015.png";